<div class="content">
  <div class="title">
    @if (data.setupCompanyReject) {
    <span>Confirmation</span>
    } @if (data.invitationCompanyReject) {
    <span>Reject company invitation</span>
    } @if (data.keyContactRoleReject) {
    <span>Reject key contact role</span>
    }
  </div>
  <div class="message">
    @if (data.setupCompanyReject || data.keyContactRoleReject) {
    <span
      >Are you sure you want to reject the responsibility for this company? It is strongly recommended to provide a new
      key contact and save your time in future, otherwise it is likely that we will need to contact you for further
      clarifications.</span
    >
    } @if (data.invitationCompanyReject) {
    <span
      >Are you sure that you want to reject this invitation? The person who invited you will be informed about your
      decision.</span
    >
    }
  </div>
  <div class="setup-form custom-form" [formGroup]="keyContactForm">
    <div class="control-group">
      <div class="label">Rejection Reason</div>
      <div class="control-box">
        <textarea class="input-form textarea" formControlName="rejectionMessage"></textarea>
        <ddd-field-error-show
          [displayError]="isFieldValid('rejectionMessage')"
          errorMsg="Please enter rejection reason."
        >
        </ddd-field-error-show>
      </div>
    </div>
    <div class="sub-title">Optional: Propose a new Key Contact for this organisation</div>
    <div class="control-group">
      <div class="label">First Name</div>
      <div class="control-box">
        <input class="input-form" type="text" formControlName="firstName" dddAppCapitalize />
      </div>
    </div>
    <div class="control-group">
      <div class="label">Last Name</div>
      <div class="control-box">
        <input class="input-form" type="text" formControlName="lastName" dddAppCapitalize />
      </div>
    </div>
    <div class="control-group">
      <div class="label">Email</div>
      <div class="control-box">
        <input class="input-form" type="text" formControlName="email" />
        @if ( !keyContactForm?.get('email')?.valid && keyContactForm?.get('email')?.value !== '' &&
        (keyContactForm?.get('email')?.touched || keyContactForm?.get('email')?.dirty) ) {
        <div class="error">Please enter valid email</div>
        }
      </div>
    </div>
    <div class="control-group">
      <div class="label">
        Landline
        <div
          class="info-icon"
          matTooltip="In case your company uses the extensions, please insert it in the following format: +000000000000 ext. 0000"
          [matTooltipPosition]="'right'"
        ></div>
      </div>
      <div class="control-box">
        <div class="phone-number-input-container">
          <div class="c-select">
            <select #countryCodeLandline>
              @if (!landlineCountryAlphaCode) {
              <option disabled selected value></option>
              } @for (country of countriesSelect; track country) {
              <option value="{{ country.alpha2Code }}" [selected]="country.alpha2Code === landlineCountryAlphaCode">
                {{ country.name }} ({{ country.phonePrefix }})
              </option>
              }
            </select>
          </div>
          <input
            class="input-form"
            type="text"
            id="landline"
            formControlName="landline"
            placeholder="landline phone"
            (blur)="validateLandline()"
            #landline
            [ngClass]="{ 'empty-error': !validateLandline() }"
          />
        </div>
        @if (!validateLandline()) {
        <div class="error">Please enter a valid landline number.</div>
        }
      </div>
    </div>
    <div class="control-group">
      <div class="label">Mobile Phone</div>
      <div class="control-box">
        <div class="phone-number-input-container">
          <div class="c-select">
            <select #mobilePhoneCountryCode>
              @if (!phoneCountryAlphaCode) {
              <option disabled selected value></option>
              } @for (country of countriesSelect; track country) {
              <option value="{{ country.alpha2Code }}" [selected]="country.alpha2Code === phoneCountryAlphaCode">
                {{ country.name }} ({{ country.phonePrefix }})
              </option>
              }
            </select>
          </div>
          <input
            class="input-form"
            type="text"
            id="phone"
            formControlName="phone"
            placeholder="mobile phone"
            (blur)="validatePhoneNumber()"
            #mobilePhone
            [ngClass]="{ 'empty-error': !validatePhoneNumber() }"
          />
        </div>
        @if (!validatePhoneNumber()) {
        <div class="error">Please enter a valid phone number.</div>
        }
      </div>
    </div>
  </div>
  <div class="actions">
    <button class="ddd-button" (click)="dialogRef.close()">Cancel</button>
    <button class="ddd-button raised" (click)="onSubmit()">
      {{ data.invitationCompanyReject || data.keyContactRoleReject ? "Reject" : "Reject responsibility" }}
    </button>
  </div>
</div>
